import React from 'react';
import classNames from 'classnames';
import { Accordion as MuiAccordion } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles({
    root: {
        userSelect: 'none',
        width: function (props) { var _a; return (_a = props.width) !== null && _a !== void 0 ? _a : '100%'; },
        height: 'auto',
    },
}, { name: 'SnAccordion' });
export var Accordion = function (props) {
    var children = props.children, classes = props.classes, className = props.className, defaultExpanded = props.defaultExpanded, expanded = props.expanded, onChange = props.onChange, id = props.id, style = props.style;
    var accordionClasses = useStyles(props);
    return (React.createElement("div", { className: classNames(accordionClasses.root, className) },
        React.createElement(MuiAccordion, { square: true, children: children, classes: classes, defaultExpanded: defaultExpanded, expanded: expanded, onChange: onChange, id: id, style: style })));
};
